import React,{useState, useEffect} from 'react';
import {databaseUrl} from '../../server/server.js';
import { useLocation } from 'react-router-dom';

import { Button } from '@mui/material';
import axiosInstance from '../../server/axios.js';

//date
import { DateRange } from 'react-date-range';
import { format } from 'date-fns';
import { ko } from 'date-fns/locale/ko';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';


const ChangeReceiveDate = () => {
    const location = useLocation();
    const idList = location.search.split('=')[1];
    const checkWeek = ['일','월','화','수','목','금','토'];
    const [company, setCompany] = useState('');
    const [inputList, setInputList] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [startday,setStartDay] = useState('');


    
    const sendChangedReceiveDate = async (confirmDate) => {
      if(window.confirm(`${confirmDate} 입고 진행?`)){
        const result = await axiosInstance.get(`${databaseUrl}/orderboard/confirmreceive?id=${idList}&chdate=${confirmDate}`)
        if(result.data === 'NotAdmin'){alert('Not permitted');}
        if(result.data === 'ok'){window.open('','_self').close();}
      }
    }
    useEffect(() => {getdata()}, [])

    const getdata =async () => {
        const response = await axiosInstance.get(`${databaseUrl}/orderboard/receivedate?id=${idList}`);
        const workList = response.data[1].map((startEnddate)=>{return {workdate:startEnddate,worklist:[]}});
        for(let i = 0,j = 0; i < response.data[2].length,j < workList.length;){
          if(response.data[2][i].due_date === workList[j].workdate){
            workList[j].worklist.push(response.data[2][i]);
            if(i === response.data[2].length -1 && j === workList.length - 1)break;
            i++;
          }else{
            if(i === response.data[2].length -1 && j === workList.length - 1)break;
            j++;
          }
        }
        setCompany(response.data[0][0].company);
        setInputList([...response.data[0]]);
        const setDate = response.data[0][0].receive_date.length === 10 ? response.data[0][0].receive_date : response.data[0][0].start_date;
        setStartDay(setDate);
        setDataList([...workList]);
    }
    const changeDay = async (value) => {
      setStartDay(value);
/*
      const sendData = await axiosInstance.post(`/orderboard/receive`,{
        companyname : companyName,
        materiallist : inputmaterial,
        startdate : startDate,
        enddate : endDate,
        receivedate : receiveDate,
        note : note,
        method : method
      })
*/
    }




    return (
        <div>
            <div>
              <table style={{marginLeft:'auto',marginRight:'auto'}}>
                <thead>
                  <tr>
                    <th>구매 업체 명 : </th>
                    <th>{company}</th> : <></>
                  </tr>
                  <tr>
                    <th colSpan={2}>입고 원료 LIST</th>
                  </tr>
                </thead>
              {inputList.map((data,i)=>
                <tr><td align='left'>{data.material}</td><td align='right'>{data.weight}</td></tr>
              )}
              </table>
              <div><h1>입고일 결정</h1></div>
            </div>
              <table style={{marginLeft:'35%',marginRight:'35%'}}>
              <tr>
                <tbody>
                   <td className='mustinput'>
                    <input type='date' 
                      style={{transform:'scale(1.5)',fontSize:'2rem'}}
                      value={startday} 
                      onChange={(event)=>changeDay(event.target.value)}>
                    </input>
                    </td> 
                </tbody>
              </tr>
              <tr>
                <tfoot>
                  <td>
                    <Button 
                    variant="contained" color="error"
                    style={{width:'350px',fontSize:'2rem'}}
                    onClick={()=>sendChangedReceiveDate(startday)}
                    >
                    전송
                    </Button>
                  </td>
                </tfoot>
              </tr>
            </table>
            <div style={{
                display:'flex',
                justifyContent:'flex-start',
                alignItems:'flex-start'
                }}>
              {dataList.map((data,i)=>
              <table style={{border:'3px solid red'}} border={1}>
                <thead>
                  <tr key={i}>
                    <th colSpan={3}>
                      <Button 
                       variant="contained" 
                       color="success"
                       onClick={()=>sendChangedReceiveDate(data.workdate)}>
                         {data.workdate}[{checkWeek[new Date(data.workdate).getDay()]}] 입고 
                      </Button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                {data.worklist.map((worklist,j)=>
                <tr>
                    <td>{worklist.visitor.substring(0,2)}</td>
                    <td>{worklist.company}</td>
                    <td>{worklist.weight}</td>
                </tr>
                )}
                </tbody>
              </table>
              )}
            </div>
        </div>
    )
}
export default ChangeReceiveDate;


/*
        <div><h1>{notaccess}</h1></div>
        <table className='table_normal'>
            <thead>
                 <tr><th colSpan="13">배송일 일괄 변경</th></tr>
            <tr>
                <th>번호</th>
                <th>접수일</th>
                <th>발주처</th>
                <th>품명</th>
                <th>수량</th>
                <th>요청납기일</th>
                <th>선입금</th>
                <th>선입금액</th>
                <th>입금일</th>
                <th>입금금액</th>
                <th>배송</th>
                <th>배송일</th>
                <th>비고</th>
            </tr>
            </thead>
            <tbody>
                {dataList.map((data,i)=>
                <tr key={i}>
                    <td>{data.id}</td>
                    <td>{data.inputdate}</td>
                    <td>{data.company}</td>
                    <td>{data.material}</td>
                    <td>{data.weight}</td>
                    <td>{data.due_date}</td>
                    <td>{data.isdeposit}</td>
                    <td>{data.depositPrice}</td>
                    <td>{data.depositDay}</td>
                    <td>{data.depositSend}</td>
                    <td>{data.delivery}</td>
                    {i === 0 ?
                        <td rowSpan={dataList.length} className='mustinput'><input type='date' value={deliverydate} onChange={(event)=>changeDeliveryDate(event.target.value)}></input></td> : ''
                    }                    
                    <td>{data.note}</td>
                </tr>                
                )}
            <tr><td colSpan='13'>
                <Button onClick={sendChangedDate} size='large' variant="contained" color="success"  sx={{width:'100%'}}>Submit</Button>
            </td>
            </tr>
            </tbody>
        </table>
*/
